/* eslint-disable no-restricted-syntax */
// components/ProductCardMemoized.jsx
/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import React, { memo } from 'react';
import ProductCardMobile from './productCard/ProductCardMobile';
var ProductCardMobileMemoized = /*#__PURE__*/memo(_ref => {
  var {
    storeStatus,
    image,
    category,
    name,
    isNewItem,
    isSpicy,
    description,
    price,
    url,
    productId,
    isCustomizable
  } = _ref;
  return /*#__PURE__*/React.createElement(ProductCardMobile, {
    storeStatus: storeStatus,
    image: image,
    category: category,
    name: name,
    isNewItem: isNewItem,
    isSpicy: isSpicy,
    description: description,
    price: price,
    url: url,
    productId: productId,
    isCustomizable: isCustomizable
  });
});
ProductCardMobileMemoized.displayName = 'ProductCardMobileMemoized';
export default ProductCardMobileMemoized;